import {Button, Col, Form, Input, InputNumber, Row, Select} from 'antd';
import React, {useContext} from 'react';
import {sideMenuContext} from '../../../router/IndexRouter';

const layout = {
	labelCol: {span: 10},
	wrapperCol: {span: 14},
};

const tailLayout = {
	wrapperCol: {offset: 5, span: 16},
};

const DetailBranchActivity = () => {
	const {currentItem} = useContext(sideMenuContext);
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			initialValues={currentItem}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="activity_name" label="活动主题" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="activity_date" label="活动时间"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activity_scope" label="参加人数"
							   rules={[{required: true, message: '内容不能为空'}]}
							   initialValue={0}>
						<InputNumber style={{width: 150}} min={0} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="activity_address" label="活动地址" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="activity_form" label="活动类别" rules={[{required: true, message: '内容不能为空'}]}
						initialValue="支部会">
						<Select disabled={true}>
							<Select.Option value="支部会">支部会</Select.Option>
							<Select.Option value="支部党员大会">支部党员大会</Select.Option>
							<Select.Option value="党小组会">党小组会</Select.Option>
							<Select.Option value="专题组织生活会">专题组织生活会</Select.Option>
							<Select.Option value="党课学习">党课学习</Select.Option>
							<Select.Option value="主题党日">主题党日</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="activity_compere" label="主持人" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="activity_memo" label="活动说明"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: currentItem.activity_memo}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailBranchActivity;

